module.exports = __webpack_public_path__ + "media/images/os_cara/eduardo-6e2184dbcaa3f47bde185d93145b68fb.png";